import { useState, useEffect } from 'react';
import { getBackendUrl } from '../lib/backend';

interface GoogleCalendar {
  id: string;
  name: string;
  primary?: boolean;
}

export const useGoogleCalendar = () => {
  const [googleCalendars, setGoogleCalendars] = useState<GoogleCalendar[]>([]);
  const [showReauthButton, setShowReauthButton] = useState(false);
  const [calendarError, setCalendarError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGoogleCalendars();
  }, []);

  const fetchGoogleCalendars = async () => {
    setLoading(true);
    setCalendarError(null);
    try {
      const response = await fetch(`${getBackendUrl()}/api/calendar/list`, {
        method: 'GET',
        credentials: 'include',
      });

      if (response.ok) {
        const calendars = await response.json();
        setGoogleCalendars(calendars);
        setShowReauthButton(false);
      } else {
        const errorData = await response.json().catch(() => ({}));
        if (errorData.needsReauth) {
          setShowReauthButton(true);
        }
        setGoogleCalendars([]);
        setCalendarError(
          errorData.error || 'No se pudieron cargar los calendarios de Google.',
        );
      }
    } catch (error) {
      console.error('Error fetching Google Calendars:', error);
      setGoogleCalendars([]);
      setCalendarError('No se pudieron cargar los calendarios de Google.');
    } finally {
      setLoading(false);
    }
  };

  const handleReauthenticate = () => {
    window.location.href = `${getBackendUrl()}/auth/google`;
  };

  return {
    googleCalendars,
    showReauthButton,
    calendarError,
    loading,
    handleReauthenticate,
    refetch: fetchGoogleCalendars,
  };
};
